import Stack from '@mui/material/Stack';

import Form from '@gef-ui/form-material/Form';

import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import { Floating } from 'components/index';
import formDescriptorFn, { NEW_CAMPAIGN_FORM_NAME } from 'features/views/campaignList/newCampaignModal/form';

import NewCampaignForm from './Form';

export const NewCampaignModalBody = () => (
	<Stack spacing={1}>
		<Floating>
			<SubmitFormDialog pageName={NEW_CAMPAIGN_FORM_NAME} />
		</Floating>
		<Form name={NEW_CAMPAIGN_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<NewCampaignForm />
		</Form>
	</Stack>
);

export default NewCampaignModalBody;
